import React from 'react';
import TestimonialsCarousel from './TestimonialsCarousel';
import testimonials from './testimonials';

const TestimonialsSection: React.FC = () => {
    return (
        <section className="bg-gray-50 py-16">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        What Our Patients Say
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Read testimonials from patients who have experienced exceptional care and results.
                    </p>
                </div>
                
                <TestimonialsCarousel testimonials={testimonials} />
            </div>
        </section>
    );
};

export default TestimonialsSection;